var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Change Personal Information"),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody personal-info",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "div",
            { class: _vm.$style.columnsContainer },
            [
              _c(
                "rb-input",
                {
                  class: _vm.$style.column,
                  attrs: {
                    "for-id": "firstName",
                    error: _vm.$showError("firstName"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("First Name"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.firstName,
                        expression: "data.firstName",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, max: 50 },
                        expression: "{required: true, max: 50}",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "firstName",
                      type: "text",
                      name: "firstName",
                      autofocus: "",
                      "data-vv-as": "First Name",
                    },
                    domProps: { value: _vm.data.firstName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.data, "firstName", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
              _c(
                "rb-input",
                {
                  class: _vm.$style.column,
                  attrs: {
                    "for-id": "lastName",
                    error: _vm.$showError("lastName"),
                  },
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Last Name"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.lastName,
                        expression: "data.lastName",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, max: 50 },
                        expression: "{required: true, max: 50}",
                      },
                    ],
                    staticClass: "rbInput",
                    attrs: {
                      id: "lastName",
                      type: "text",
                      name: "lastName",
                      "data-vv-as": "Last Name",
                    },
                    domProps: { value: _vm.data.lastName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.data, "lastName", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "rb-input",
            { attrs: { "for-id": "phone", error: _vm.$showError("phone") } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Phone"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.phone,
                    expression: "data.phone",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      max: 20,
                      regex:
                        /^(\+|00)?[(]?[0-9]{0,3}[)]?[-\s.]?[[0-9]{0,3}]?[-\s./]?[[0-9]{0,3}]?[-\s.]?[0-9]{3,7}$/,
                    },
                    expression:
                      "{ max:20, regex: /^(\\+|00)?[(]?[0-9]{0,3}[)]?[-\\s.]?[[0-9]{0,3}]?[-\\s./]?[[0-9]{0,3}]?[-\\s.]?[0-9]{3,7}$/ }",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "phone",
                  type: "text",
                  name: "phone",
                  "data-vv-as": "Phone Number",
                },
                domProps: { value: _vm.data.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data, "phone", $event.target.value)
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }